import ManageTabs from './ManageTabsButton';
import TabsRow from './TabsRow';

const Tabs = {
  ManageTabs,
  TabsRow,
};

export default Tabs;
